import React from 'react';

import { PiTrophy, PiToilet } from 'react-icons/pi';

import {
    Box,
    P,
} from '@saladbob/sassafras';

import styles from './bracket.module.css';

type Props = {
    trophy?: boolean,
    tb?: boolean,
    color?: string | [string, string],
    loserColor?: string | [string, string],
    loserTrophy?: boolean,
    position?: 'top' | 'bottom',
};

const trophyStyle: React.CSSProperties = {
    position: 'absolute',
    top: 0,
    right: 0,
    transform: 'translate(50%, -50%)',
}

const trophyStyleBottom: React.CSSProperties = {
    position: 'absolute',
    bottom: 0,
    right: 0,
    transform: 'translate(50%, 50%)',
}

const ts = {
    top: trophyStyle,
    bottom: trophyStyleBottom,
}

const lineStyle: React.CSSProperties = {
    position: 'absolute',
    bottom: '100%',
    width: 'auto',
};

const borderStyle = {
    top: {
        borderLeft: 'none',
        borderRight: 'none',
        borderBottom: 'none',
    } as React.CSSProperties, 
    bottom: {
        borderLeft: 'none',
        borderRight: 'none',
        borderTop: 'none',
    } as React.CSSProperties,
}

const ByGame: React.FC<Props> = ({ position = 'top', trophy, loserTrophy, loserColor = 'neutral', tb, color = 'tertiary700'}) => {
    return (
        <Box className={styles.byGame} style={{ height: '100%' }} >
            <Box
                className={styles.gameBorder}
                height="100%"
                minWidth="100px"
                bdColor="black"
                bdWidth="2px"
                style={borderStyle[position]}
            >
                <P mb="xs" width="auto" style={lineStyle}></P>
                {loserTrophy && (
                    <div className={`${styles.loserTrophy} ${styles['trophy' + position]}`}>
                        <Box
                            width="56px"
                            height="56px"
                            bgColor={typeof loserColor === 'string' ? loserColor : loserColor[0]}
                            txtColor={typeof loserColor === 'string' ? 'white' : loserColor[1]}
                            rounded="100%"
                            align="center"
                            justify="center"
                        >
                            <PiTrophy size={32} />
                        </Box>
                    </div>
                )}
                {(trophy || tb) && (
                    <div className={`${styles.trophy} ${styles['trophy' + position]}`} style={ts[position]}>
                        <Box
                            width="56px"
                            height="56px"
                            bgColor={typeof color === 'string' ? color : color[0]}
                            txtColor={typeof color === 'string' ? 'white' : color[1]}
                            rounded="100%"
                            align="center"
                            justify="center"
                        >
                            {trophy && <PiTrophy size={32} />}
                            {tb && <PiToilet size={32} />}
                        </Box>
                    </div>
                )}
            </Box>
        </Box>
    );
}

export default ByGame;
